/**
 * Whole layout area / window
 */
export const layoutId = 'annotation-tool-layout';

/**
 * Header
 */

export const headerAreaId = 'annotation-tool-header-area';
export const appHeaderHeight = 56;

/**
 * Content
 */
export const contentAreaId = 'annotation-tool-primary-content-area';
export const primaryViewAreaId = 'annotation-tool-primary-view-area';

/**
 * Toolbar
 */
export const toolbarAreaId = 'annotation-tool-toolbar-area';
export const appToolbarWidth = 48;

/**
 * Sider
 */
export const siderHeaderTitleId = 'annotation-tool-sider-header-area';
export const siderAreaId = 'annotation-tool-sider-area';

/**
 * Tooling Footer
 */
export const defaultFooterHeight = 232;
export const footerAreaId = 'annotation-tool-footer-area';

/**
 * Global Footer
 */
export const globalFooterAreaId = 'global-footer-area';
